import { createContext } from 'react';
import { UploaderController } from './UploaderController';
import { IUploaderContext } from './models';

export const UploaderContext = createContext<IUploaderContext>({
  controller: new UploaderController(),
  id: '',
  uploadFile: () => {},
  isMulti: undefined,
  entityFieldId: '',
  entityId: 'taskAttachment',
  uploaderTitle: '',
  uploaderTitleTooltip: '',
  multiItemExtention: undefined,
});
